import { OrNull } from '@app/utils/types.helper';
import { Address } from '@app/interfaces/contact.interface';

export interface ImportAddressesResponse {
  totalExcelRows: number;
  parsedRows: number;
  relevantAddresses: number;
  needManualReview: number;
  corrected: number;
  moved: number;
  changes: AddressChangeRecord[];
  errors: ImportRowError[];
}

/**
 * Describes a single change (or a flagged manual-review case) applied to a
 * contact's address as a result of processing the Swiss Post response file.
 */
export interface AddressChangeRecord {
  contactId: number;
  contactName: string;
  organization: OrNull<string>;
  kind: string; // WORK or HOME
  action: AddressChangeAction;
  qstat: SwissPostQstat;
  qstatDescription: string;
  oldAddress: OrNull<Address>;
  newAddress: Address;
  changedFields: ChangedFields[];
}

export enum ChangedFields {
  STREET = 'STREET',
  POSTAL_CODE = 'POSTAL_CODE',
  CITY = 'CITY',
  CANTON = 'CANTON',
  COUNTRY = 'COUNTRY',
}

export interface ImportRowError {
  row: number;
  customerId?: string;
  message: string;
}

/**
 * QSTAT status codes returned by Swiss Post for each address that was submitted
 * for validation/correction.
 *
 *  |  Code  | Meaning                                                            |
 *  |--------|--------------------------------------------------------------------|
 *  |   1    | A person matched                                                   |
 *  |   2    | A household matched                                                |
 *  |   3    | A company matched                                                  |
 *  |   4    | The person or company has moved (see "Gültig ab" for mutation date)|
 *  |   25   | Deceased / Company no longer in business                           |
 *  |   26   | International relocation hit                                       |
 *  |   27   | Relocated, The new address is unknown                              |
 *  |   50   | Person unknown at this address                                     |
 *  |   51   | Address unknown                                                    |
 */
export enum SwissPostQstat {
  PERSON_MATCHED = 1,
  HOUSEHOLD_MATCHED = 2,
  COMPANY_MATCHED = 3,
  MOVED = 4,
  DECEASED_OR_BUSINESS_CLOSED = 25,
  INTERNATIONAL_RELOCATION = 26,
  RELOCATED_UNKNOWN_ADDRESS = 27,
  PERSON_UNKNOWN = 50,
  ADDRESS_UNKNOWN = 51,
}

export enum AddressChangeAction {
  MOVED = 'moved',
  CORRECTED = 'corrected',
  MANUAL_REVIEW = 'manual_review',
}
